/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const FacilityPage = lazyLoad(
  () => import('./index'),
  module => module.FacilityPage,
);
